import {DefaultTheme} from 'styled-components/macro';

const Light: DefaultTheme = {
    color: {
        primary: '#222222',
        secondary : '#898F97',
        danger: '#FF3347',
        indicator : '#007AFF',
        primaryBackground : '#FFFFFF',
        secondaryBackground : '#F3F4F5',
        secondaryIcon : '#C4C7CB',
        selected : '#D9EBFF',
        septenary: '#16C67A',
        warning: '#FC832D',
    },
    border : {
        default : '1px solid rgba(0, 0, 0, 0.08)',
        error : '1px solid #FF3347',
        active: '1px solid #007AFF'
    },
    mask: 'rgba(88, 86, 86, 0.65)'
};

const Dark = {
    color: {
        primary: '#222222',
        secondary : '#898F97',
        danger: '#FF3347',
        indicator : '#007AFF',
        primaryBackground : '#FFFFFF',
        secondaryBackground : '#F3F4F5',
        secondaryIcon : '#C4C7CB',
        selected : '#D9EBFF',
        septenary: '#16C67A',
        warning: '#FC832D',
    },
    border : {
        default : '1px solid rgba(0, 0, 0, 0.08)',
        error : '1px solid #FF3347',
        active: '1px solid #007AFF'
    },
    mask: 'rgba(88, 86, 86, 0.65)'
};

export {
    Light,
    Dark
};
